<template>
  <v-app>
    <!-- <v-toolbar color="#FAF7F2" light flat style="float:right;" class="mb" v-if="$route.name.indexOf('Portal/') < 0">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
    </v-toolbar> -->
    <div id="app" >
      <HeaderItem01 />
      <v-content transition="slide-x-transition">
          <router-view></router-view>
      </v-content>
      <!-- <footer class="fixed_footer min_box"> -->
      <FooterItem01 />
      <!-- </footer> -->
    </div>
  </v-app>
</template>

<script>
import HeaderItem01 from './components/HeaderItem01';
import FooterItem01 from './components/FooterItem01';
// import Mausestalker from './components/mouseStalker.vue'

export default {
  name: 'App',

  components: {
    HeaderItem01,
    FooterItem01,
    // Mausestalker
  },
  head: {
    link: [
      {
        rel: 'stylesheet',
        href:
          'https://fonts.googleapis.com/css2?family=Overpass:wght@100&family=Source+Code+Pro:wght@200&display=swap',
      },
    ],
  },

  data(){
    return{
      drawer: false,
  }},
  methods : {
    createPageTitle : function(){
    //タイトルを設定
      document.title = '株式会社HES リクルートサイト'
    },
  },
  mounted() {
    this.createPageTitle()
  }

};
</script>

<style>
/* @import "./css/base.css"; */
</style>

